import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AdapterService } from '../../../core/services/adapter.service';
import { NotificationService } from '../../../core/services/notification.service';
import { NumberService } from '../../services/number.service';
import { CartService } from 'src/app/core/services/cart.service';
import { DeleteCartItemModalComponent } from '../delete-cart-item-modal/delete-cart-item-modal.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { ProductService } from 'src/app/core/services/product.service';
import operations from 'src/assets/data/operations';
import { SpecialPricingOrderType } from '../../../core/enums/special-pricing-order-type.enum';
import { MouldingType } from '../../../core/enums/moulding-type.enum';

@Component({
  selector: 'app-cart-list-modal',
  templateUrl: './cart-list-modal.component.html',
  styleUrls: ['./cart-list-modal.component.scss']
})
export class CartListModalComponent implements OnInit {
  //itemList: any = [];
  orderList: any[] = [];
  quoteList: any[] = [];
  isLoading: boolean;

  constructor(public _activeModal: NgbActiveModal,
    private _router: Router,
    private _authService: AuthService,
    private _adapterService: AdapterService,
    private readonly _cartService: CartService,
    private readonly _productService: ProductService,
    public _notificationService: NotificationService,
    public _ns: NumberService,
    private _modalService: NgbModal) { }

  ngOnInit(): void {
    this.initializeList();

    this._cartService.onCartUpdate.subscribe((source: any) => {
      if (source !== this)
        this.initializeList();
    });
  }
  initializeList() {
    const loggedInUser = this._authService.getLoggedInUser();
    this.isLoading = true;
    this._cartService.getCartItems(loggedInUser?.cartId)
      .subscribe((response) => {
        if (response?.value?.data) {
          //this.itemList = list;
          let list = response?.value?.data;
          console.log(list);
          this.orderList = list.filter(item => item.orderTypeId == 1 || item.orderTypeId == 2);
          this.quoteList = list.filter(item => item.orderTypeId == 3 || item.orderTypeId == 4);
          // this.orderList = list.filter((item: { isQuote: any; }) => !item.isQuote);
          // this.quoteList = list.filter((item: { isQuote: any; }) => item.isQuote);
    
          // if (list.find(item => item.hasCategory))
          //   this.hasProductCategoryAdded = true;
    
          //this._adapterService.removeLocalStorageValue(`fotiou.cartlist`);
        }

        this.isLoading = false;
      });

    // let list = this._adapterService.getLocalStorageValue(environment.storageKeys.cart)
    // if (list) {
    //   //this.itemList = list;
    //   this.orderList = list.filter((item: { isQuote: any; }) => !item.isQuote);
    //   this.quoteList = list.filter((item: { isQuote: any; }) => item.isQuote);
    //   //this._adapterService.removeLocalStorageValue(`fotiou.cartlist`);
    // }
  }
  close() {
    this._activeModal.close();
  }

  viewCart() {
    this._router.navigate([`/orders/cart-list`]);
    this.close();
  }

  checkout() {
    this._router.navigate([`/orders/checkout`])
    this.close();
  }

  checkIfObject = (obj) => {
    let type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  }
 
  deleteItem(item: any) {
    const ngbModalOptions: any = {
      backdrop: true,
      keyboard: false,
      windowClass: "delete-cartitem"
    };
    const modalRef = this._modalService.open(ConfirmationModalComponent, ngbModalOptions);
    modalRef.componentInstance.title = "Delete Cart Item";
    modalRef.componentInstance.message = "Do you want to delete this item?";
    modalRef.result.then((response) => {
      if (response) {
        item.isUpdating = true;
        this._cartService.deleteCartItem(item.id)
        .subscribe((response) => {
          this.initializeList();
          this._cartService.notifyCartUpdate(this);
        });
        // toDeleteFromList.splice(index, 1);
        // //this.table.renderRows();
        // const itemList: any[] = [...this.orderList, ...this.quoteList];
        // this._adapterService.removeLocalStorageValue(environment.storageKeys.cart);
        // this._adapterService.setLocalStorageValue(environment.storageKeys.cart, itemList);
        // this._notificationService.getServerCount();
        // this._cartService.notifyCartUpdate(this);
      }
    });
  }

  quantityChange(item: any) {
    item.isUpdating = true;

    const loggedInUser = this._authService.getLoggedInUser();
    const operation = operations.find(operation => item.operation === operation.name);
    const orderType = operation.mouldingType == MouldingType.Length ? SpecialPricingOrderType.supply : SpecialPricingOrderType.custom;
    this._productService.getPrice(loggedInUser?.userId, item.productId, "CDN", item.width + item.length, operation.mouldingType, item.quantity, orderType)
      .subscribe((response) => {
        const toUpdateCartItem = {
          id: item.id,
          quantity: item.quantity,
          discountId: response?.value?.data?.discountId,
          discountPercentage: response?.value?.data?.discountPercentage,
          discountedPrice: response?.value?.data?.unitPrice,
          subTotal: response?.value?.data?.totalExtendedPrice,
          price: response?.value?.data?.nonDiscountedUnitPrice
        };

        this._cartService.updateCartItem(toUpdateCartItem).subscribe((response) => {
          item.discountId = toUpdateCartItem.discountId;
          item.price = toUpdateCartItem.price;
          item.discountedPrice = toUpdateCartItem.discountedPrice;
          item.discountPercentage = toUpdateCartItem.discountPercentage;
          item.subTotal = toUpdateCartItem.subTotal;

          item.isUpdating = false;
          this._cartService.notifyCartUpdate(this);
        });
      });

    // for (let item of this.orderList) {
    //   if (item.quantity <= 0 || typeof item.quantity != 'number') {
    //     item.quantity = 1;
    //   }
    // }
    // for (let item of this.quoteList) {
    //   if (item.quantity <= 0 || typeof item.quantity != 'number') {
    //     item.quantity = 1;
    //   }
    // }
    // //this.table.renderRows();
    // const itemList: any[] = [...this.orderList, ...this.quoteList];
    // this._adapterService.removeLocalStorageValue(environment.storageKeys.cart);
    // this._adapterService.setLocalStorageValue(environment.storageKeys.cart, itemList);
    // this._cartService.notifyCartUpdate(this);
  }

  getListSubTotalPrice(itemList: any[]) {
    if (!itemList || itemList.length === 0) return 0;

    let listSubTotalPrice = 0;
    itemList.forEach(item => {
      listSubTotalPrice += item.subTotal;

      if (item.childCartItem) {
        item.childCartItem.forEach(subItem => {
          listSubTotalPrice += subItem.subTotal;
        });
      }
    });

    return listSubTotalPrice;
  }
}
